import NextImage from "@components/NextImage";
import React from "react";

import {RootStateLocation} from "../../../store/types";
import {s3ImageSource} from "../../../useS3ImgSrc";
import styles from "./Photos.module.scss";

const Photos = ({location}: {location: RootStateLocation}) => {
  const {images} = location;

  return (
    // @ts-expect-error TS2532: Object is possibly 'undefined'.
    <div className={`has-${images.length}-images hidden lg:block`}>
      <div className={styles.imgs}>
        {/* @ts-expect-error TS2532: Object is possibly 'undefined'. */}
        {images.slice(0, 4).map(img => (
          <div key={img.imageId} className={styles.img}>
            <NextImage
              priority
              src={s3ImageSource(img.imageId)}
              layout="fill"
              objectFit="cover"
              alt=""
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Photos;
